import React, { useCallback, useMemo, useState } from "react";
import { Col, CustomInput, Input, Row } from "reactstrap";

import { Settings } from "./types";

type Props = Readonly<{
  currentSettings: Settings;
  updateSettings: (s: Settings) => void;
}>;

export const SettingsComponent = ({ currentSettings, updateSettings }: Props) => {
  return (
    <>
      <Row className="align-items-center">
        <Col xs={8}>Switch to text</Col>
        <Col className="text-right" xs={4}>
          <CustomInput
            bsSize="lg"
            checked={currentSettings.automaticallyJumpToText}
            id="toggleSwitchToText"
            onChange={() => {
              updateSettings({
                ...currentSettings,
                automaticallyJumpToText: !currentSettings.automaticallyJumpToText,
              });
            }}
            type="switch"
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-muted">
          Selecting a block in the document view will automatically scroll to its related block in
          the text view.
        </Col>
      </Row>
      <hr />
      <Row className="align-items-center">
        <Col xs={8}>Automatically scroll document</Col>
        <Col className="text-right" xs={4}>
          <CustomInput
            bsSize="lg"
            checked={currentSettings.automaticallyScrollDocument}
            id="toggleAutoScrollDocument"
            onChange={() => {
              updateSettings({
                ...currentSettings,
                automaticallyScrollDocument: !currentSettings.automaticallyScrollDocument,
              });
            }}
            type="switch"
          />
        </Col>
      </Row>
      <Row>
        <Col className="text-muted">
          The document view will automatically scroll based on the selected data point.
        </Col>
      </Row>
      <hr />
      {/*<Row className="align-items-center">
        <Col xs={8}>Openai API key</Col>
      </Row>
      <Row className="align-items-center">
        <Input
          style={{margin:"0px 15px"}}
          onChange={(e) => {
            updateSettings({
              ...currentSettings,
              openaiApiKey: e.target.value,
            });
          }}
          value={currentSettings.openaiApiKey}
        />
        </Row>
      <Row>
        <Col className="text-muted">
          This will activate the openai tab and allow prompting GPT for data
        </Col>
      </Row>*/}
    </>
  );
};
SettingsComponent.displayName = "Settings";

const MAPPING_SETTINGS_KEY = "mapping.ui.settings";

export const useSettings = (): [Settings, (s: Settings) => void] => {
  const defaultSettings = useMemo((): Settings => {
    const defaults: Settings = {
      automaticallyJumpToText: false,
      automaticallyScrollDocument: true,
    };
    const storedSettings = window.localStorage.getItem(MAPPING_SETTINGS_KEY);
    if (storedSettings && typeof storedSettings === "string") {
      try {
        const parsedStoredSettings = JSON.parse(storedSettings);
        return {
          ...defaults,
          ...parsedStoredSettings,
        };
      } catch (err) {
        // do nothing
      }
    }
    return defaults;
  }, []);
  const [settings, rawUpdateSettings] = useState<Settings>(defaultSettings);
  const updateSettings = useCallback(
    (s: Settings) => {
      rawUpdateSettings(s);
      window.localStorage.setItem(MAPPING_SETTINGS_KEY, JSON.stringify(s));
    },
    [rawUpdateSettings],
  );
  return [settings, updateSettings];
};
